import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=20874d7a&scoped=true&"
import script from "./customTable.vue?vue&type=script&lang=ts&"
export * from "./customTable.vue?vue&type=script&lang=ts&"
import style0 from "./customTable.vue?vue&type=style&index=0&id=20874d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20874d7a",
  null
  
)

export default component.exports